import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { mapBackendUserToUser } from 'src/config/api/models';
import { BackendUser, User } from 'src/config/api/models/User';
import apiRoutesV2, { baseURL } from 'src/config/api/routes';
import { RootState } from 'src/modules/shared/store';
import { setJwt, setUser } from '../auth/entity/AuthSlice';

type BackEndImpersonate = {
  token: string;
  user: BackendUser;
  code: number;
};

type Impersonate = {
  token: string;
  user: { data: User };
  code: number;
};

export const impersonateApi = createApi({
  reducerPath: 'impersonateApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.jwt;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    postImpersonate: builder.mutation<Impersonate, string>({
      query: (userId) => ({
        url: apiRoutesV2.impersonate(userId),
        method: 'POST',
      }),
      transformResponse: (response: { data: BackEndImpersonate }) => {
        const mappedUser: User = mapBackendUserToUser(response.data.user);
        const newData: Impersonate = { ...response.data, user: { data: mappedUser } };
        return newData;
      },
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setJwt(data.token));
          dispatch(setUser(data.user.data as User));
        } catch (err) {
          console.log('error postImpersonate');
        }
      },
    }),
    postLeaveImpersonate: builder.mutation<Impersonate, void>({
      query: () => ({
        url: apiRoutesV2.leaveImpersonation(),
        method: 'DELETE',
      }),
      transformResponse: (response: { data: BackEndImpersonate }) => {
        const mappedUser: User = mapBackendUserToUser(response.data.user);
        const newData: Impersonate = { ...response.data, user: { data: mappedUser } };
        return newData;
      },
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setJwt(data.token));
          dispatch(setUser(data.user.data as User));
        } catch (err) {
          console.log('error deleteLeaveImpersonate');
        }
      },
    }),
  }),
});

export const { usePostImpersonateMutation, usePostLeaveImpersonateMutation } = impersonateApi;
